import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import BordSteps from 'components/NudosComponents/BordSteps/BordSteps';
import { fgDefault } from 'styles/styles.constants';
import './BulkUploadHeader.scss';

interface BulkUploadHeaderProps {
  steps: string[];
  currentStep: number;
  goBackText?: string;
  handleBack: () => void;
}
const BulkUploadHeader = ({ steps, currentStep, handleBack, goBackText = '' }: BulkUploadHeaderProps) => {
  return (
    <section className="bulkUploadHeader">
      <div className="goBackButton" onClick={handleBack}>
        <BordOneToneIcon
          variant="arrowHeadLeft"
          customWidth="16px"
          stroke={fgDefault}
          standardSize={14}
          className="goBackButtonIcon"
        />
        <span className="goBackButtonText">{goBackText}</span>
      </div>
      <BordSteps steps={steps} currentStep={currentStep} />
      <span className='voidRightItem'></span>
    </section>
  );
};

export default BulkUploadHeader;
